/**
 * Split a form field's label into the section it sits in and the question itself.
 *
 * Labels read off a form often carry their whole heading: "1. Patient details (main member to
 * complete on behalf of: Telephone (H)". Shown as one line on every field, the heading buries the
 * question. Split at the last ": ", and if the heading part opens a bracket it never closes (the
 * form's own wording ran into the field), the heading stops before that bracket.
 */
export function splitQuestion(label: string | null | undefined): { section: string | null; question: string } {
  const text = (label || '').trim();
  const at = text.lastIndexOf(': ');
  if (at <= 0 || !text.slice(at + 2).trim()) return { section: null, question: text };

  let section = text.slice(0, at).trim();
  const question = text.slice(at + 2).trim();

  const opens = (section.match(/\(/g) || []).length;
  const closes = (section.match(/\)/g) || []).length;
  if (opens > closes) section = section.slice(0, section.lastIndexOf('(')).trim();

  return { section: section || null, question };
}
